export enum ExpertStatus {
  All = 'all',
  Pending = 'pending',
  Active = 'active',
}

export function getExpertStatusLabel(status: ExpertStatus): string {
  switch (status) {
    case ExpertStatus.All: {
      return 'All';
    }
    case ExpertStatus.Pending: {
      return 'Pending';
    }
    case ExpertStatus.Active: {
      return 'Active';
    }
  }
}

const EXPERT_STATUS_ORDER: ExpertStatus[] = [
  ExpertStatus.All,
  ExpertStatus.Pending,
  ExpertStatus.Active,
];

export const EXPERT_STATUS_FILTER_OPTIONS = EXPERT_STATUS_ORDER.map(
  (value) => ({ value, label: getExpertStatusLabel(value) }),
);
